function flattenResources(resources) {
  const { bundles } = resources?.resourceBundles ?? {};
  const flatBundles = {};
  for (const key in bundles) {
    if (bundles.hasOwnProperty(key)) {
      const newKey = key.split(".")[key.split(".").length - 1];
      const { properties = {} } = bundles[key];
      flatBundles[newKey] = properties;
    }
  }
  return flatBundles;
}
export {
  flattenResources
};
//# sourceMappingURL=flatten-resources.js.map
